import './setPublicPath';
import { getAppContainerElement } from 'helpers/helpers';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

const container = getAppContainerElement();

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
